import script from "./NewNode.vue?vue&type=script&lang=js"
export * from "./NewNode.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__